module.exports = __webpack_public_path__ + "static/melanydierks-CV-64c97c7a910bd2ab2b982fd60578b75a.pdf";